import { STRIPE_TIER } from '#components/Settings/Org/plans'
import {
  billingFailure,
  usePortal,
  usePricingTableSession,
} from '#components/Settings/Org/useBillingPlan'
import { IOrg, useMst } from '#state'

import { showError } from './Error'
import { showPricingTableModal } from './PricingTable'
import { showUpgradeInquiryModal } from './UpgradeInquiry'

export const useUpgrade = () => {
  const { currentOrg } = useMst()
  const portal = usePortal()
  const pricingTableSession = usePricingTableSession()

  const resubscribe = async () => {
    try {
      const { clientSecret } = await pricingTableSession.createSession()
      showPricingTableModal({ customerSessionClientSecret: clientSecret })
    } catch (err) {
      showError({
        message: billingFailure(err, 'Failed to open plans').message,
      })
    }
  }

  const startSelfServe = async () => {
    if (currentOrg?.isLapsedStripeAccount) return resubscribe()

    const { success, code, message } = await portal.openPortal()
    if (success) return

    if (code === 'NO_SUBSCRIPTION') {
      showPricingTableModal()
    } else {
      showError({ message })
    }
  }

  const upgrade = async (org: IOrg) =>
    org.tier === STRIPE_TIER ? startSelfServe() : showUpgradeInquiryModal(org)

  return {
    pending: portal.pending || pricingTableSession.pending,
    upgrade,
    startSelfServe,
  }
}
